import React from 'react';
import { getLocationFromCoordinates, getLocationFromMap, TakeOffMarker } from '@src/core/controllers';
import { useDispatch, useSelector } from 'react-redux';
import { useGetUserDataQuery } from '@src/core/features';
import { selectTakeOffLocation, setTakeOffLocation } from '@src/features/order/pages/upsert-order-page/redux';
import { TakeOffPointProps } from './types';

const TakeOffPoint: React.FC<TakeOffPointProps> = ({ draggable = true, seedFromHub = true }) => {
  const dispatch = useDispatch();
  const { data } = useGetUserDataQuery();
  const location = useSelector(selectTakeOffLocation);

  const onDragEnd = async (e: google.maps.MapMouseEvent) => {
    const location = await getLocationFromMap(e);
    
    if (!location) return;
  
    dispatch(setTakeOffLocation(location));
  };

  React.useEffect(() => {
    if (!seedFromHub) return;

    const lat = Number(data?.hub?.latitude);
    const lng = Number(data?.hub?.longitude);

    if (!lat || !lng) return;

    let cancelled = false;

    (async () => {
      const resolved = await getLocationFromCoordinates(lat, lng);
      if (cancelled) return;

      dispatch(setTakeOffLocation({
        address: resolved?.address ?? data?.hub?.name ?? '',
        latitude: lat,
        longitude: lng,
      }));
    })();

    return () => {
      cancelled = true;
    };
  }, [seedFromHub, data?.hub, dispatch]);



  const lat = Number(location?.latitude);
  const lng = Number(location?.longitude);

  if (isNaN(lat) || isNaN(lng)) return null;

  return (
    <TakeOffMarker.confirmed 
      draggable={draggable}
      zIndex={2000}
      position={{ lat, lng }} 
      onDragEnd={onDragEnd} />
  );
};

export default TakeOffPoint;
